<template>
  <figure class="device-frame my-8">
    <div class="device-frame__bezel">
      <span class="device-frame__camera" aria-hidden="true" />
      <div class="device-frame__screen">
        <NuxtImg
          :src="src"
          :alt="alt"
          loading="lazy"
          format="webp"
          sizes="sm:100vw md:720px lg:860px"
          class="device-frame__img"
        />
      </div>
    </div>
    <figcaption v-if="caption" class="device-frame__caption">{{ caption }}</figcaption>
  </figure>
</template>

<script setup lang="ts">
defineProps<{
  src: string
  alt: string
  caption?: string
}>()
</script>

<style scoped>
.device-frame {
  max-width: 860px;
  margin-inline: auto;
}

/* iPad-style space-gray bezel — reads well on both light and dark backgrounds */
.device-frame__bezel {
  position: relative;
  padding: 16px;
  border-radius: 28px;
  background: linear-gradient(145deg, #2c2f34, #15171a);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    inset 0 0 0 1px rgba(0, 0, 0, 0.4),
    0 22px 48px rgba(0, 0, 0, 0.22);
}

/* Front camera dot, centered on the left short edge (landscape orientation) */
.device-frame__camera {
  position: absolute;
  top: 50%;
  left: 7px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: radial-gradient(circle at 35% 35%, #4a4d52, #0c0d0f);
  transform: translateY(-50%);
}

.device-frame__screen {
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  line-height: 0;
}

.device-frame__img {
  display: block;
  margin: 0;
  width: 100%;
  height: auto;
}

.device-frame__caption {
  margin-top: 0.85rem;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.5;
  opacity: 0.7;
}
</style>
